<template>
    <div class="tab-content p-2 text-center" v-if="!isLoaded">
        {{ $t('loading') }}
    </div>

    <div v-else>
        <div class="mx-auto col-lg-4 col-md-6 col-sm-12 header-margin">
            <div class="text-center p-2 mb-4">
                <h3>AUBE</h3>
                <p>{{ $t('aube_quest.integrate.cooperation_confirmation') }}</p>
            </div>
            <div class="d-flex justify-content-center my-4">
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none"
                     stroke="green" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="24" cy="24" r="22" stroke="green" fill="none"/>
                    <path d="M14 24l6 6 14-14"/>
                </svg>
            </div>
            <h4 class="mb-3 text-center">{{ $t('aube_quest.connected.title_info1') }}</h4>
            <div class="info-box">
                <p class="text-muted">{{ $t('aube_quest.connected.title_info2') }}</p>
                <div class="info-box text-left">
                    <div class="mb-2">
                        <small class="text-muted">{{ $t('aube_quest.connected.title_mail') }}</small>
                        <div class="font-weight-bold">{{ email }}</div>
                    </div>
                    <div>
                        <small class="text-muted">{{ $t('aube_quest.title_quest_id') }}</small>
                        <div class="font-weight-bold">{{ questId }}</div>
                    </div>
                </div>
            </div>

            <router-link class="btn btn-primary btn-block mt-3" to="/">
                {{ $t('aube_quest.btn_go_dashboard') }}
            </router-link>
        </div>
    </div>
</template>

<script>
import UserService from '../../../services/UserService';


export default {
    name: 'connected-complete',
    data() {
        return {
            isLoaded: false,
            email: null,
            questId: null
        }
    },
    created() {
        this.getEmail();
    },
    methods: {
        async getEmail() {

            try {
                const data = await UserService.getUserFrontendData();
                this.email = data.data.email;
                this.questId = data.data.quest.quest_id;
                this.isLoaded = true;
            } catch (e) {
            } finally {
            }
        },
    }
}
</script>

<style scoped>

.info-box {
    background-color: #f8f9fa;
    padding: 15px;
    border-radius: 4px;
    margin-bottom: 20px;
}

.default-box {
    border: darkgray solid 1px;
    padding: 15px;
    border-radius: 4px;
    margin-bottom: 20px;
}

.btn-primary {
    background: #451493 !important;
    border-color: #451493 !important;
}

.btn-primary:hover {
    color: #fff !important;
    background-color: #350f71 !important;
    border-color: #300e66 !important;
}
</style>
